module.exports = __webpack_public_path__ + "img/2Crowdmarketing Innovation.ae10b7c2.png";